'use client'

import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { Combobox } from '@/components/ui/combobox'
import { useMetaStore } from '@/store'

type PropsType = {
  id?: string
  value?: string
  onValueChange?: (value: string) => void
  disabled?: boolean
  clearable?: boolean
  error?: boolean
  className?: string
}

const LocaleCombobox = ({ id, value, onValueChange, disabled, clearable = false, error, className }: PropsType) => {
  const t = useTranslations()
  const { metaState } = useMetaStore()

  const options = useMemo(
    () =>
      (metaState.response?.locales || []).map(locale => ({
        label: locale.name,
        value: locale.fullCode,
        description: locale.fullCode,
        searchValue: `${locale.name} ${locale.fullCode}`
      })),
    [metaState.response?.locales]
  )

  return (
    <Combobox
      id={id}
      options={options}
      value={value}
      onValueChange={val => onValueChange?.(val as string)}
      placeholder={t('select')}
      searchPlaceholder={t('search')}
      emptyText={t('not_found')}
      disabled={disabled}
      clearable={clearable}
      error={error}
      className={className}
    />
  )
}

export default LocaleCombobox
